import { BASE_URL } from 'config';
import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  Typography,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  Autocomplete,
} from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";

const AddShippingPricingForm = ({ onClose, onSuccess, initialData }) => {
  console.log("🚀 ~ AddShippingPricingForm ~ initialData:", initialData);
  const [shippingMethods, setShippingMethods] = useState([]);

  const [countries, setCountries] = useState([]);

  const [originRegions, setOriginRegions] = useState([]);
  const [originCities, setOriginCities] = useState([]);

  const [destinationRegions, setDestinationRegions] = useState([]);
  const [destinationCities, setDestinationCities] = useState([]);

  const [formData, setFormData] = useState({
    shipping_method_id: initialData?.shipping_method_id || "",
    origin_country_id: initialData?.origin_country_id || "",
    origin_region_id: initialData?.origin_region.id || "",
    origin_city_id: initialData?.origin_city?.id || "",
    destination_country_id: initialData?.destination_country_id || "",
    destination_region_id: initialData?.destination_region?.id || "",
    destination_city_id: initialData?.destination_city?.id || "",
    weight: initialData?.weight || "",
    height: initialData?.height || "",
    width: initialData?.width || "",
    depth: initialData?.depth || "",
    price: initialData?.price || "",
    id: initialData?.id || null,
  });

  // تحميل شركات الشحن
  useEffect(() => {
    const fetchShippingMethods = async () => {
      const token = localStorage.getItem("user-token");
      try {
        const response = await fetch(
          BASE_URL + "/administrator/shipping-methods",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const data = await response.json();
        setShippingMethods(data.data || []);
      } catch (error) {
        setShippingMethods([]);
        console.error(error);
      }
    };
    fetchShippingMethods();
  }, []);

  // تحميل الدول
  useEffect(() => {
    const fetchCountries = async () => {
      const token = localStorage.getItem("user-token");
      try {
        const response = await fetch(
          BASE_URL + "/administrator/locations/countries",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const data = await response.json();
        setCountries(data.data || []);
      } catch (error) {
        setCountries([]);
        console.error(error);
      }
    };
    fetchCountries();
  }, []);

  // تحميل مناطق المنشأ عند اختيار الدولة
  useEffect(() => {
    if (!formData.origin_country_id) {
      setOriginRegions([]);
      setOriginCities([]);
      return;
    }
    const fetchRegions = async () => {
      const token = localStorage.getItem("user-token");
      try {
        const response = await fetch(
          `${BASE_URL}/administrator/locations/children/${formData.origin_country_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const data = await response.json();
        setOriginRegions(data.data || []);
        setOriginCities([]); // امسح المدن لما المنطقة تتغير
      } catch (error) {
        setOriginRegions([]);
        setOriginCities([]);
        console.error(error);
      }
    };
    fetchRegions();
  }, [formData.origin_country_id]);

  // تحميل محافظات المنشأ عند اختيار المنطقة
  useEffect(() => {
    if (!formData.origin_region_id) {
      setOriginCities([]);
      return;
    }
    const fetchCities = async () => {
      const token = localStorage.getItem("user-token");
      try {
        const response = await fetch(
          `${BASE_URL}/administrator/locations/children/${formData.origin_region_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const data = await response.json();
        setOriginCities(data.data || []);
      } catch (error) {
        setOriginCities([]);
        console.error(error);
      }
    };
    fetchCities();
  }, [formData.origin_region_id]);

  // تحميل مناطق الوجهة عند اختيار الدولة
  useEffect(() => {
    if (!formData.destination_country_id) {
      setDestinationRegions([]);
      setDestinationCities([]);
      return;
    }
    const fetchRegions = async () => {
      const token = localStorage.getItem("user-token");
      try {
        const response = await fetch(
          `${BASE_URL}/administrator/locations/children/${formData.destination_country_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const data = await response.json();
        setDestinationRegions(data.data || []);
        setDestinationCities([]);
      } catch (error) {
        setDestinationRegions([]);
        setDestinationCities([]);
        console.error(error);
      }
    };
    fetchRegions();
  }, [formData.destination_country_id]);

  // تحميل محافظات الوجهة عند اختيار المنطقة
  useEffect(() => {
    if (!formData.destination_region_id) {
      setDestinationCities([]);
      return;
    }
    const fetchCities = async () => {
      const token = localStorage.getItem("user-token");
      try {
        const response = await fetch(
          `${BASE_URL}/administrator/locations/children/${formData.destination_region_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const data = await response.json();
        setDestinationCities(data.data || []);
      } catch (error) {
        setDestinationCities([]);
        console.error(error);
      }
    };
    fetchCities();
  }, [formData.destination_region_id]);

  // handle form changes for inputs and selects
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // handle changes for Autocomplete (Origin and Destination)
  const handleAutocompleteChange = (field, newValue, resetFields = []) => {
    setFormData((prev) => {
      const updated = { ...prev, [field]: newValue?.id || "" };
      resetFields.forEach((f) => (updated[f] = ""));
      return updated;
    });
  };

  // Validation (basic)
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    const newErrors = {};
    if (!formData.shipping_method_id) newErrors.shipping_method_id = "اختر شركة الشحن";
    if (!formData.origin_country_id) newErrors.origin_country_id = "اختر دولة المنشأ";
    if (!formData.origin_region_id) newErrors.origin_region_id = "اختر منطقة المنشأ";
    if (!formData.origin_city_id) newErrors.origin_city_id = "اختر محافظة المنشأ";
    if (!formData.destination_country_id) newErrors.destination_country_id = "اختر دولة الوجهة";
    if (!formData.destination_region_id) newErrors.destination_region_id = "اختر منطقة الوجهة";
    if (!formData.destination_city_id) newErrors.destination_city_id = "اختر محافظة الوجهة";
    if (!formData.price || formData.price <= 0) newErrors.price = "أدخل سعر الشحن الصحيح";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      Swal.fire({
        title: "جاري الحفظ...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const formPayload = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && key !== "id") {
          formPayload.append(key, value);
        }
      });

      const token = localStorage.getItem("user-token");
      const endpoint = formData.id
        ? `${BASE_URL}/administrator/shipping-rates/update/${formData.id}`
        : BASE_URL + "/administrator/shipping-rates/store";

      const response = await axios.post(endpoint, formPayload, {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` },
      });

      Swal.close();

      if (response.data.status) {
        Swal.fire({ icon: "success", title: "تم الحفظ", confirmButtonText: "موافق" });
        onSuccess();
        onClose();
      } else {
        throw new Error(response.data.message || "حدث خطأ");
      }
    } catch (error) {
      Swal.close();
      Swal.fire({ icon: "error", title: "خطأ", text: error.message || "حدث خطأ" });
    }
  };

  return (
    <Box
      component="form"
      noValidate
      onSubmit={handleSubmit}
      sx={{
        p: 3,
        maxWidth: 600,
        mx: "auto",
        bgcolor: "background.paper",
        borderRadius: 3,
        boxShadow: 3,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Typography variant="h5" align="center" gutterBottom>
        إضافة سعر شحن جديد
      </Typography>

      {/* شركة الشحن */}
      <FormControl fullWidth error={!!errors.shipping_method_id}>
        <InputLabel id="shipping-method-label">شركة الشحن</InputLabel>
        <Select
          labelId="shipping-method-label"
          label="شركة الشحن"
          name="shipping_method_id"
          value={formData.shipping_method_id}
          onChange={handleChange}
          sx={{ textAlign: "right", p: 2 }}
        >
          {shippingMethods.map((sm) => (
            <MenuItem key={sm.id} value={sm.id}>
              {sm.name}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>{errors.shipping_method_id}</FormHelperText>
      </FormControl>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
        {/* منشأ */}
        <Box sx={{ flex: "1 1 30%", mb: 1 }}>
          <Autocomplete
            options={countries}
            getOptionLabel={(option) => option.name || ""}
            value={countries.find((c) => c.id === formData.origin_country_id) || null}
            onChange={(e, newVal) =>
              handleAutocompleteChange("origin_country_id", newVal, [
                "origin_region_id",
                "origin_city_id",
              ])
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="دولة المنشأ"
                error={!!errors.origin_country_id}
                helperText={errors.origin_country_id}
              />
            )}
          />
        </Box>
        <Box sx={{ flex: "1 1 30%", mb: 1 }}>
          <Autocomplete
            options={originRegions}
            getOptionLabel={(option) => option.name || ""}
            value={originRegions.find((r) => r.id === formData.origin_region_id) || null}
            onChange={(e, newVal) =>
              handleAutocompleteChange("origin_region_id", newVal, ["origin_city_id"])
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="منطقة المنشأ"
                error={!!errors.origin_region_id}
                helperText={errors.origin_region_id}
              />
            )}
          />
        </Box>
        <Box sx={{ flex: "1 1 30%", mb: 1 }}>
          <Autocomplete
            options={originCities}
            getOptionLabel={(option) => option.name || ""}
            value={originCities.find((c) => c.id === formData.origin_city_id) || null}
            onChange={(e, newVal) => handleAutocompleteChange("origin_city_id", newVal)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="محافظة المنشأ"
                error={!!errors.origin_city_id}
                helperText={errors.origin_city_id}
              />
            )}
          />
        </Box>

        {/* الوجهة */}
        <Box sx={{ flex: "1 1 30%", mb: 1 }}>
          <Autocomplete
            options={countries}
            getOptionLabel={(option) => option.name || ""}
            value={countries.find((c) => c.id === formData.destination_country_id) || null}
            onChange={(e, newVal) =>
              handleAutocompleteChange("destination_country_id", newVal, [
                "destination_region_id",
                "destination_city_id",
              ])
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="دولة الوجهة"
                error={!!errors.destination_country_id}
                helperText={errors.destination_country_id}
              />
            )}
          />
        </Box>
        <Box sx={{ flex: "1 1 30%", mb: 1 }}>
          <Autocomplete
            options={destinationRegions}
            getOptionLabel={(option) => option.name || ""}
            value={destinationRegions.find((r) => r.id === formData.destination_region_id) || null}
            onChange={(e, newVal) =>
              handleAutocompleteChange("destination_region_id", newVal, ["destination_city_id"])
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="منطقة الوجهة"
                error={!!errors.destination_region_id}
                helperText={errors.destination_region_id}
              />
            )}
          />
        </Box>
        <Box sx={{ flex: "1 1 30%", mb: 1 }}>
          <Autocomplete
            options={destinationCities}
            getOptionLabel={(option) => option.name || ""}
            value={destinationCities.find((c) => c.id === formData.destination_city_id) || null}
            onChange={(e, newVal) => handleAutocompleteChange("destination_city_id", newVal)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="محافظة الوجهة"
                error={!!errors.destination_city_id}
                helperText={errors.destination_city_id}
              />
            )}
          />
        </Box>
        {/*  */}
      </Box>

      <Box sx={{ display: "flex", gap: 2 }}>
        <TextField
          label="وزن المنتج (كجم)"
          type="number"
          required
          name="weight"
          inputProps={{ step: 1, min: 0 }}
          fullWidth
          value={formData.weight}
          onChange={handleChange}
          sx={{ mb: 3 }}
        />
        <TextField
          label="الارتفاع (سم)"
          type="number"
          required
          inputProps={{ step: 1, min: 0 }}
          name="height"
          fullWidth
          value={formData.height}
          onChange={handleChange}
        />
        <TextField
          label="العرض (سم)"
          type="number"
          name="width"
          inputProps={{ step: 1, min: 0 }}
          required
          fullWidth
          value={formData.width}
          onChange={handleChange}
        />
        <TextField
          label="العمق (سم)"
          type="number"
          required
          inputProps={{ step: 1, min: 0 }}
          name="depth"
          fullWidth
          value={formData.depth}
          onChange={handleChange}
        />
      </Box>
      {/* السعر */}
      <TextField
        label="سعر الشحن"
        name="price"
        inputProps={{ step: 1, min: 0 }}
        type="number"
        value={formData.price}
        onChange={handleChange}
        error={!!errors.price}
        helperText={errors.price}
        fullWidth
      />

      {/* أزرار */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
        <Button variant="outlined" color="error" onClick={onClose}>
          إلغاء
        </Button>
        <Button variant="contained" color="primary" type="submit">
          حفظ
        </Button>
      </Box>
    </Box>
  );
};

export default AddShippingPricingForm;
